// @flow
import React, {PureComponent} from 'react'
import {Endring} from '../../shared/Endring'
import {Prosent} from '../../shared/Prosent/index'
import {bem} from '../../shared/bem'

import {
  oppslutningEnkelChart as chart,
  oppslutningEnkelChart__column as column,
  oppslutningEnkelChart__partyName as partyName,
  oppslutningEnkelChart__percentageValue as percentageValue,
  oppslutningEnkelChart__diffValue as diffValue,
  oppslutningEnkelChart__barContainer as barContainer,
  oppslutningEnkelChart__bar as bar
} from './index.css'

export type OppslutningEnkelGraphItem = {
  navn: string,
  kortNavn: string,
  prosent: number,
  endringProsent: number,
  antallStemmer: number,
  sortering: number
}

export type OppslutningEnkelGraphProps = {
  id: string,
  items: Array<OppslutningEnkelGraphItem>,
  type: 'land' | 'fylke' | 'kommune' | 'krets',
  headingLevel: number
}

export class OppslutningEnkelGraph extends PureComponent {
  props: OppslutningEnkelGraphProps

  constructor(props: OppslutningEnkelGraphProps) {
    super()
    this.props = props
  }

  render() {
    const {items, type} = this.props
    const id = `ot-${this.props.id}`
    return (
      <div id={id}>
        <div className={bem(chart, type)}>
          {items.map(item => {
            const {navn, kortNavn, prosent, endringProsent} = item
            return (
              <div className={column} key={kortNavn}>
                <h3 className={partyName}>
                  <span>
                    {kortNavn}
                  </span>
                  <span className="nrk-sr">
                    {navn}
                  </span>
                </h3>
                <div className={barContainer}>
                  <div className={percentageValue}>
                    <Prosent prosent={prosent} />
                  </div>
                  <div
                    className={bem(bar, kortNavn.toLowerCase())}
                    style={{
                      width: `${prosent * 1.5}%`,
                      height: `${prosent * 1.5}%`
                    }}
                  />
                </div>
                <div className={diffValue}>
                  <Endring endring={endringProsent} />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/oppslutningEnkel/OppslutningEnkelGraph/index.js